import {Platform, StyleSheet} from 'react-native';

// Theme-aware styles factory (docs/DARK-MODE.md). Style-as-function entries
// (tagContainer, buttonsContainer, button) are preserved — the factory returns
// them closed over the theme's colors.
const makeStyles = colors =>
  StyleSheet.create({
    container: {
      flex: 1,
      backgroundColor: colors.backgroundMuted,
    },
    marginHorizontal24: {
      marginHorizontal: 24,
    },
    marginVertical16: {
      marginVertical: 16,
    },
    marginTop16: {
      marginTop: 16,
    },
    pageViewContainer: {
      marginBottom: 16,
      marginTop: 16,
    },
    tagContainer: index => ({
      padding: 8,
      borderRadius: 8,
      backgroundColor: colors.surface,
      marginLeft: index == 0 ? 0 : 16,
    }),
    emptyListContainer: {
      marginTop: 100,
      marginBottom: 50,
      alignItems: 'center',
    },
    buttonsContainer: bottom => ({
      flexDirection: 'row',
      marginHorizontal: 24,
      marginBottom: bottom,
    }),
    button: leftMargin => ({
      flex: 1,
      marginLeft: leftMargin,
    }),
    underlineText: {
      borderBottomColor: colors.link,
      borderBottomWidth: 1,
    },
    titleContainer: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      marginTop: 24,
      marginHorizontal: 24,
    },
    cardView: {
      marginTop: 16,
      backgroundColor: colors.surface,
      borderRadius: 16,
      paddingHorizontal: 12,
      paddingVertical: 16,
      shadowColor: colors.shadow,
      shadowOpacity: 0.12,
      shadowRadius: 30,
      shadowOffset: {width: 0, height: 30},
      elevation: 30,
      marginHorizontal: 24,
    },
    rowContainer: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginTop: 8,
      // Keep label and value apart at large accessibility font sizes.
      gap: 16,
    },
    rowLabel: {
      flexShrink: 0,
    },
    rowValue: {
      // Let long values (street addresses) wrap under system font scaling
      // instead of colliding with the label.
      flex: 1,
      textAlign: 'right',
    },
    scrollContainer: {
      paddingTop: 8,
      paddingBottom: 24,
    },
    flexDirection: {
      flexDirection: Platform.OS === 'web' ? 'row' : 'column',
    },
    width65: {
      width: '65%',
    },
    width35: {
      width: '35%',
    },
  });

export default makeStyles;
